import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errorText } from "../lib/api";
import { useAuth, fmtDate } from "./AuthContext";

const PasswordForm = () => {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password changed");
      setCur(""); setNw("");
    } catch (err) { toast.error(errorText(err)); }
  };
  return (
    <form onSubmit={submit} className="panel p-6 space-y-3" data-testid="admin-change-password-form">
      <h2 className="text-xl font-bold uppercase">Change your password</h2>
      <input type="password" autoComplete="current-password" className="tow-input" placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} required data-testid="admin-current-password" />
      <input type="password" autoComplete="new-password" minLength={10} className="tow-input" placeholder="New password (min 10 characters)" value={nw} onChange={(e) => setNw(e.target.value)} required data-testid="admin-new-password" />
      <button type="submit" className="btn-yellow px-5 py-2.5 text-sm" data-testid="admin-change-password-btn">Update password</button>
    </form>
  );
};

const AdminList = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ email: "", name: "", password: "" });
  const load = () => api.get("/auth/admins").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/admins", form);
      toast.success("Administrator added");
      setForm({ email: "", name: "", password: "" });
      load();
    } catch (err) { toast.error(errorText(err)); }
  };
  const remove = async (a) => {
    if (!window.confirm(`Remove ${a.email}?`)) return;
    try { await api.delete(`/auth/admins/${a.id}`); load(); } catch (err) { toast.error(errorText(err)); }
  };
  return (
    <div className="panel p-6 space-y-4" data-testid="admin-team-list">
      <h2 className="text-xl font-bold uppercase">Administrators</h2>
      <ul className="divide-y divide-[#2E2E3A]">
        {list.map((a) => (
          <li key={a.id} className="flex items-center justify-between py-3 text-sm">
            <span><span className="font-semibold">{a.email}</span> <span className="ml-2 rounded-full border border-[#3F3F4E] px-2 py-0.5 text-xs uppercase">{a.role}</span><span className="block text-xs text-gray-500">Last login {fmtDate(a.last_login_at)}</span></span>
            {a.role !== "owner" && <button type="button" onClick={() => remove(a)} aria-label={`Remove ${a.email}`} className="text-red-400 hover:text-red-300" data-testid={`admin-remove-${a.email}`}><Trash2 className="h-4 w-4" /></button>}
          </li>
        ))}
      </ul>
      <form onSubmit={add} className="grid gap-2 sm:grid-cols-4">
        <input type="email" className="tow-input" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-new-email" />
        <input className="tow-input" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="admin-new-name" />
        <input type="password" autoComplete="new-password" minLength={10} className="tow-input" placeholder="Temporary password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-new-password-input" />
        <button type="submit" className="btn-yellow px-4 py-3 text-sm" data-testid="admin-add-admin-btn">Add admin</button>
      </form>
    </div>
  );
};

export default function Team() {
  const { user } = useAuth();
  return (
    <div className="space-y-6 max-w-3xl" data-testid="admin-team-page">
      <h1 className="text-3xl sm:text-4xl font-extrabold uppercase">Team & security</h1>
      <PasswordForm />
      {user?.role === "owner" ? <AdminList /> : <p className="text-sm text-gray-400">Only the business owner can manage administrator accounts.</p>}
    </div>
  );
}
